window.addEventListener("load", function () {
  const setCookie = (name, value, days) => (document.cookie = `${name}=${value}; max-age=${days * 24 * 60 * 60}; path=/`);
  const isCookieSet = (name) => document.cookie.split("; ").some((c) => c.startsWith(name + "="));

  if (isCookieSet("chateau-age-verification")) {
    return;
  }

  const ageRestriction = document.querySelector(".age-restriction");

  if (!ageRestriction) {
    return;
  }

  ageRestriction.classList.add("active");
  document.body.classList.add("overflow-hidden");

  const buttonPositive = ageRestriction.querySelector(".age-restriction__positive");

  buttonPositive.addEventListener("click", function () {
    setCookie("chateau-age-verification", "1", 60);
    ageRestriction.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  });
});
